import { motion } from 'framer-motion';
import { Sparkles, CheckCircle2, Phone } from 'lucide-react';

const ServicesPage = () => {
  const services = [
    { title: "Cornrows", desc: "Tension-free, natural looking braids that protect your edges.", img: "/images/conrows.jpg", alt: "Cornrows Styling Charlotte NC" },
    { title: "Boho Box Braids", desc: "The trendy bohemian look with curly ends for a soft finish.", img: "/images/bohoboxpp.jpg", alt: "Boho Box Braids Charlotte NC" },
    { title: "Traditional Box Braids", desc: "Classic, versatile, and long-lasting protective style.", img: "/images/boxpp.jpg", alt: "Traditional Box Braids Charlotte NC" },
    { title: "Mohawk Braids", desc: "Edgy, bold style with shaved sides and braided center strip.", img: "/images/borabora.jpg", alt: "Mohawk Braids Charlotte NC" },
    { title: "Bora Braids", desc: "Unique braided patterns for a distinctive look.", img: "/images/fppic.jpg", alt: "Bora Braids Charlotte NC" },
    { title: "Bob Box Braids", desc: "Classic braids patterns for vintage look.", img: "/images/bobbox.jpg", alt: "Bob Box Braids Charlotte NC" },
    { title: "Stitched Cornrows", desc: "Unique braided patterns for a pretty look.", img: "/images/stitches.jpg", alt: "Stitched Cornrows Charlotte NC" },
    { title: "Knotless Braids", desc: "Long-lasting protective style with a natural finish.", img: "/images/IMG-20251024-WA0054.jpg", alt: "Knotless Braids Charlotte NC" },
    { title: "Senegalese Twists", desc: "Elegant and protective style with a smooth finish.", img: "/images/seneg.jpg", alt: "Senegalese Twists Charlotte NC" },
    { title: "Comb Braids", desc: "Simple and exclusive style for a sharp look.", img: "/images/combraid.jpg", alt: "Comb Braids Charlotte NC" },
  ];

  return (
    <div className="pt-24 pb-32 px-4 bg-cream relative overflow-hidden">
      {/* Background Ambience */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-sunset/5 rounded-full blur-[120px] pointer-events-none animate-pulse-slow"></div>
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-royal/5 rounded-full blur-[150px] pointer-events-none animate-float"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-24"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sunset/10 border border-sunset/20 mb-6">
            <Sparkles className="text-sunset w-4 h-4 animate-pulse" />
            <span className="text-sunset text-[10px] font-bold uppercase tracking-[0.3em]">Signature Collections</span>
          </div>
          <h1 className="text-6xl md:text-8xl font-serif font-bold text-dark mb-8 tracking-tighter">
            Elevated <br /><span className="text-gradient-vibrant italic">Excellence</span>
          </h1>
          <p className="text-xl text-gray-500 max-w-2xl mx-auto font-light leading-relaxed">
            Discover our curated range of professional braiding services, where every style is a masterpiece of precision and care.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -10 }}
              className="group bg-white rounded-[40px] overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.05)] hover:shadow-platinum transition-all duration-500 border border-transparent hover:border-gold/20"
            >
              <div className="relative h-80 overflow-hidden">
                <img
                  src={service.img}
                  alt={service.alt || service.title}
                  className="w-full h-full object-cover transition-transform duration-[2s] group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-dark/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>

              <div className="p-10">
                <h3 className="text-2xl font-serif font-bold text-dark mb-4 tracking-tight group-hover:text-gold transition-colors">{service.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-8 font-medium">
                  {service.desc}
                </p>

                <div className="flex flex-col gap-3 pt-6 border-t border-gray-100">
                  <div className="flex items-center gap-2 text-[10px] uppercase font-bold tracking-widest text-gold/60 mb-2">
                    <CheckCircle2 size={12} />
                    Premium Fiber Included
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <motion.a
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      href="tel:17046417227"
                      className="bg-dark text-white py-3 rounded-xl flex items-center justify-center gap-2 text-[10px] font-bold uppercase tracking-widest hover:bg-gradient-vibrant hover:text-white transition-all duration-300 shadow-premium"
                    >
                      <Phone size={14} /> Call
                    </motion.a>
                    <motion.a
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      href="sms:17046417227"
                      className="border border-dark/10 text-dark py-3 rounded-xl flex items-center justify-center gap-2 text-[10px] font-bold uppercase tracking-widest hover:bg-dark hover:text-white transition-all duration-300"
                    >
                      <Sparkles size={14} /> Text
                    </motion.a>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;